import React from 'react'
import { Box } from '@mui/material'
import { Text } from '@react-pdf/renderer'

interface DraftWatermarkProps {
  show: boolean
}

export const DraftWatermark: React.FC<DraftWatermarkProps> = ({ show }) => {
  if (!show) return null

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%) rotate(-45deg)',
        fontSize: '120px',
        fontWeight: 'bold',
        color: 'rgba(255, 0, 0, 0.15)',
        zIndex: 0,
        pointerEvents: 'none',
        userSelect: 'none',
        letterSpacing: '20px',
      }}
    >
      DRAFT
    </Box>
  )
}

export const DraftWatermarkForPDF = ({ show }: { show: boolean }) => {
  if (!show) return null

  return (
    <Text
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        fontSize: 80,
        fontWeight: 'bold',
        color: 'rgba(255, 0, 0, 0.15)',
        transform: 'translate(-50%, -50%) rotate(-45deg)',
      }}
      fixed
    >
      DRAFT
    </Text>
  )
}